const styles = theme => ({
  rowFlex: {
    flex: 1
  },
  quantity: {
    width: '54.04%',
    marginRight: theme.spacing.unit * 2
  },
  productTitle: {
    marginBottom: theme.spacing.unit * 3
  },
  weight: {
    width: '9vw'
  },
  hazMat: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    height: 56
  },
  codeFields: {
    marginRight: theme.spacing.unit * 2,
    '&:last-child': {
      marginRight: 0
    }
  },
  productAction: {
    position: 'absolute',
    top: -8,
    right: 0,
    textDecoration: 'none'
  },
  productActionLabel: {
    fontWeight: 500,
    color: theme.palette.primary.main
  },
  titleWrapper: {
    position: 'relative'
  }
});
export default styles;
